"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _require = require("./utils.js"),
    asciiLowercase = _require.asciiLowercase,
    solelyContainsHTTPTokenCodePoints = _require.solelyContainsHTTPTokenCodePoints,
    soleyContainsHTTPQuotedStringTokenCodePoints = _require.soleyContainsHTTPQuotedStringTokenCodePoints;

module.exports = /*#__PURE__*/function (_Symbol$iterator) {
  function MIMETypeParameters(map) {
    _classCallCheck(this, MIMETypeParameters);

    this._map = map;
  }

  _createClass(MIMETypeParameters, [{
    key: "size",
    get: function get() {
      return this._map.size;
    }
  }, {
    key: "get",
    value: function get(name) {
      name = asciiLowercase(String(name));
      return this._map.get(name);
    }
  }, {
    key: "has",
    value: function has(name) {
      name = asciiLowercase(String(name));
      return this._map.has(name);
    }
  }, {
    key: "set",
    value: function set(name, value) {
      name = asciiLowercase(String(name));
      value = String(value);

      if (!solelyContainsHTTPTokenCodePoints(name)) {
        throw new Error("Invalid MIME type parameter name \"".concat(name, "\": only HTTP token code points are valid."));
      }

      if (!soleyContainsHTTPQuotedStringTokenCodePoints(value)) {
        throw new Error("Invalid MIME type parameter value \"".concat(value, "\": only HTTP quoted-string token code points are ") + "valid.");
      }

      return this._map.set(name, value);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._map.clear();
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      name = asciiLowercase(String(name));
      return this._map.delete(name);
    }
  }, {
    key: "forEach",
    value: function forEach(callbackFn, thisArg) {
      this._map.forEach(callbackFn, thisArg);
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._map.keys();
    }
  }, {
    key: "values",
    value: function values() {
      return this._map.values();
    }
  }, {
    key: "entries",
    value: function entries() {
      return this._map.entries();
    }
  }, {
    key: _Symbol$iterator,
    value: function value() {
      return this._map[Symbol.iterator]();
    }
  }]);

  return MIMETypeParameters;
}(Symbol.iterator);